import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'ecp-help-info',
  templateUrl: './help-info.component.html',
  styleUrls: ['./help-info.component.css']
})
export class HelpInfoComponent implements OnInit {
  @Input() ecpStyle: object = {};
  isShowHelpInfo = false;
  showList = null;

  mouseOut() {
    const self = this;
    self.showList = setTimeout(function () {
      self.isShowHelpInfo = false;
    }, 200);
  }

  cleanTime() {
    const self = this;
    clearTimeout(self.showList);
  }

  constructor() {
  }

  ngOnInit() {
  }

}
